export default __webpack_public_path__ + "static/media/UKCB-Logo.eefc4685.png";